<template>
  <div :class="['basket-page__info', summAlarm]">
    <span
      class="basket-page__info__name"
    >
      {{ workMode.isModeSollers ? $t('common.advance_balance') : $t('common.credit_limit') }}:
      <span :class="['basket-page__info__value', summAlarm]">
        {{ limitBalance | numberFormatter }}
        <span class="rouble">i</span>
      </span>
    </span>

    <div class="basket-page__info__wrapper">
      <span class="basket-page__info__name">
        {{ $t('common.order_dealers_price') }}:
        <span :class="['basket-page__info__value', summAlarm]">
          {{ total.total | numberFormatter }}
          <span class="rouble">i</span>
        </span>
      </span>
      <span class="basket-page__info__name">
        {{ $t('common.total_vat') }}:
        <span class="basket-page__info__value">
          {{ total.totalVAT | numberFormatter }}
          <span class="rouble">i</span>
        </span>
      </span>
      <span class="basket-page__info__name">
        {{ $t('common.order_dealers_price_vat') }}:
        <span
          :class="['basket-page__info__value', summAlarm]"
        >
          {{ total.totalWithVAT | numberFormatter }}
          <span class="rouble">i</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {

  name: 'CartSubTotal',

  props: {
    total: {
      type: Object,
      required: true,
    },
    limitBalance: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(['workMode']),

    summAlarm() {
      return (this.total.totalWithVAT > this.limitBalance) ? 'exhausted' : '';
    },
  },
};
</script>

<style lang="scss">
.basket-page {
  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    background-color: #fff;
    margin-bottom: 32px;

    &__name {
      color: var(--faint);
    }

    &__value {
      font-weight: 500;
      color: var(--topaz);
    }

    &__wrapper {
      display: grid;
      grid-template-columns: repeat(3, auto);
      column-gap: 40px;
    }
  }
}

.exhausted.basket-page__info {
    border: solid 1px var(--red);
}

.exhausted.basket-page__info__value {
    color: var(--red);
}
</style>
